import { getStorageValue, useTranslation } from '@sm360/hooks'
import { updateListingEvent, updatePageView } from '@sm360/helpers'
import PropTypes from 'prop-types'
import React from 'react'

import { getHubsListAPIUrl, getInventoryFiltersAPIUrl } from '../../apis/filters/filters.service'
import { getInventoryPromotionsApiUrl } from '../../apis/promotion/promotion.service'
import { getShowroom360ConfigListingApiUrl, getSortingFiltersAPIUrl } from '../../apis/showroom360/showroom360.service'
import { getInventoryListingApiUrl } from '../../apis/vehicles/vehicles.service'
import { getWidgetTradeIn360APIUrl } from '../../apis/widget/widget.service'
import { FILTER_OPTIONS_REMOVED_FROM_URL, FILTER_OPTIONS_TYPES } from '../../constants/filterOptions'
import { FilterMetaDataModel } from '../../models/FilterMetaDataModel'
import { motoInsight } from '../../third-parties/thirdParties'
import { findSelectedHubCategory, getHubPathName, handleCanonicalUrl, removeHubNameGroup } from '../../utils/handle-url.utils'
import { isEmptyObject, isNumber, isObject, sortBy } from '../../utils/helper.utils'

const initialState = {
    forceUpdate: false,
    clearFilters: false,
    isFetching: true,
    isLoadingSkeleton: true,
    paymentInformationUpdate: false,
    vehicles: [],
    pagination: {},
    paymentOptions: {},
    displayBaseballCards: false,
    filters: {},
    promoBanner: [],
    promoCards: [],
    pathUrlInfos: {
        lang: '',
        inventory: '',
        makeName: '',
        modelName: '',
        langUrl: '',
        inventoryUrl: '',
        makeUrl: '',
        modelUrl: '',
    },
    XMSConfig: {
        configuration: {},
        conditionsConfigurations: [],
        highlightConfigurations: [],
        inventoryNewCompareConfiguration: {},
        inventoryUsedCompareConfiguration: {},
        pictureConfiguration: {},
        statusConfigurations: [],
        taggingConfigurations: [],
        filtersConfigurations: {},
        callForPriceThreshold: 0,
        tripleMathBoxConfiguration: {},
    },
    dealerInfos: {
        dealerBac: '',
        domain: '',
        lang: '',
        location: '',
        orgId: '',
        orgUnitCity: '',
        orgUnitId: '',
        orgUnitMakes: [],
        orgUnitName: '',
        orgUnitProvince: '',
        websiteId: '',
    },
    hubName: '',
    hubCategories: [],
    hubGroupCategories: [],
    sortConfigurations: [],
    urlParams: {},
    vehicleCriteria: {},
    vehicleCtas: [],
    filterMetaData: [],
    seoContent: [],
    resetHubCategories: false,
    isFetchingFilters: false,
    isInitialFetched: false,
    selectedHubCategory: {},
    icomoon: {},
    packageVersion: '',
    showVehicleTagline: true,
    isHumberview: false,
    tradeInWidget: {
        tradeInBeforePayments: '',
        tradeInAfterPayments: '',
        tradeInBeforeListing: '',
        tradeInAfterListing: '',
    },
    defaultPurchaseMethod: '',
    websiteVehiclesPerPage: null,
    isFirstLoad: true,
    isFetchingTradeInWidget: true,
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'fetching': {
            return {
                ...state,
                isFetching: true,
            }
        }
        case 'fetchSucceed': {
            return {
                ...state,
                isFetching: false,
            }
        }
        case 'updateState': {
            return {
                ...state,
                ...action.state,
            }
        }
        case 'init': {
            return {
                ...state,
                vehicles: action.vehicles,
                pagination: action.pagination,
                paymentOptions: action.paymentOptions,
                displayBaseballCards: action.displayBaseballCards,
                promoBanner: action.promoBanner,
                promoCards: action.promoCards,
                filters: action.filters,
                hubCategories: action.hubCategories,
                hubGroupCategories: action.hubGroupCategories,
                hubName: action.hubName,
                urlParams: action.urlParams,
                pathUrlInfos: action.pathUrlInfos,
                dealerInfos: action.dealerInfos,
                XMSConfig: action.XMSConfig,
                vehicleCriteria: action.vehicleCriteria,
                vehicleCtas: action.vehicleCtas,
                filterMetaData: action.filterMetaData,
                sortConfigurations: action.sortConfigurations,
                seoContent: action.seoContent,
                isInitialFetched: true,
                selectedHubCategory: action.selectedHubCategory,
                icomoon: action.icomoon,
                packageVersion: action.packageVersion,
                showVehicleTagline: action.showVehicleTagline,
                tradeInWidget: action.tradeInWidget,
                isFetching: action.isFetching,
                isHumberview: action.isHumberview,
                defaultPurchaseMethod: action.defaultPurchaseMethod,
                websiteVehiclesPerPage: action.websiteVehiclesPerPage,
            }
        }
        case 'updateSortConfigurations': {
            return {
                ...state,
                sortConfigurations: action.sortConfigurations,
            }
        }
        case 'updateVehicles': {
            return {
                ...state,
                vehicles: action.vehicles,
                pagination: action.pagination,
                paymentOptions: action.paymentOptions,
                displayBaseballCards: action.displayBaseballCards,
                // filterMetaData: action.filterMetaData,
            }
        }
        case 'updateVehicleCriteria': {
            return {
                ...state,
                vehicleCriteria: action.vehicleCriteria,
            }
        }
        case 'forceUpdate': {
            return {
                ...state,
                forceUpdate: action.forceUpdate,
            }
        }
        case 'clearFilters': {
            return {
                ...state,
                clearFilters: action.clearFilters,
            }
        }
        case 'updateFilters': {
            return {
                ...state,
                filters: action.filters,
                filterMetaData: action.filterMetaData,
                promoBanner: action.promoBanner,
                promoCards: action.promoCards,
            }
        }
        case 'updateHubName': {
            return {
                ...state,
                hubName: action.hubName,
                selectedHubCategory: action.selectedHubCategory,
            }
        }
        case 'updateHubCategories': {
            return {
                ...state,
                hubCategories: action.hubCategories,
                hubGroupCategories: action.hubGroupCategories,
            }
        }
        case 'updatePaymentInformation': {
            return {
                ...state,
                paymentInformationUpdate: action.paymentInformationUpdate,
            }
        }
        case 'resetHubCategories': {
            return {
                ...state,
                resetHubCategories: action.resetHubCategories,
            }
        }
        case 'fetchingFilters': {
            return {
                ...state,
                isFetchingFilters: action.isFetchingFilters,
            }
        }
        case 'updatePromoCards': {
            return {
                ...state,
                promoCards: action.promoCards,
            }
        }
        // case 'updatePromoCardsAndBanner': {
        //     return {
        //         ...state,
        //         promoCards: action.promoCards,
        //         promoBanner: action.promoBanner,
        //     }
        // }
        case 'loadingSkeleton': {
            return {
                ...state,
                isLoadingSkeleton: action.isLoadingSkeleton,
            }
        }
        // To keep track if the listing is loaded for First time or not
        case 'setFirstLoadComplete': {
            return {
                ...state,
                isFirstLoad: false,
            }
        }
        case 'fetchingTradeInWidget': {
            return {
                ...state,
                isFetchingTradeInWidget: true,
            }
        }
        case 'tradeInWidgetFetchSucceed': {
            return {
                ...state,
                isFetchingTradeInWidget: false,
            }
        }
        case 'updateTradeInWidget': {
            return {
                ...state,
                tradeInWidget: {
                    tradeInBeforeListing: action.tradeInBeforeListing,
                    tradeInAfterListing: action.tradeInAfterListing,
                    tradeInBeforePayments: action.tradeInBeforePayments,
                    tradeInAfterPayments: action.tradeInAfterPayments,
                },
            }
        }
        default:
            return state
    }
}

const ListingContext = React.createContext(initialState)

const ListingProvider = ({ initialData, children }) => {
    const [state, dispatch] = React.useReducer(reducer, initialState)

    const {
        isFetching,
        vehicleCriteria,
        forceUpdate,
        clearFilters,
        resetHubCategories,
        isInitialFetched,
        selectedHubCategory,
        hubName: initialHubName,
        paymentInformationUpdate,
        dealerInfos: { orgUnitId, location, lang: initialLang, domain },
        isHumberview,
        isFirstLoad,
        packageVersion,
        sortConfigurations,
    } = state

    const { t, i18n } = useTranslation()

    const lang = initialLang || i18n?.language
    const hubName = initialHubName || getHubPathName(lang, location, orgUnitId)

    // TODO: Remove this isHumberview flag once we have config from Delta
    const showPromoCards = !isHumberview

    const paramsPromoCards = {
        location: 'inventory.vehicles.promo.card',
    }

    if (!isInitialFetched) {
        if (initialData) {
            dispatch({ type: 'init', ...initialData })
        }
    }

    React.useEffect(() => {
        if (!isFetching && window.MOTOINSIGHT) motoInsight()
    }, [isFetching])

    React.useEffect(() => {
        // TO DO: Remove after testing promo card changes
        // fetchPromoCardAndBanner()
        fetchListingVehicles()
        fetchTradeInWidget()
    }, [])

    React.useEffect(() => {
        const fetchData = async () => {
            const urlParams = await fetchUrlParams()
            handleCanonicalUrl(lang)
            if (Object.keys(vehicleCriteria).length > 0 || forceUpdate || clearFilters) {
                await fetchFilteredInventoryListing(hubName, urlParams)
                await fetchFilterData()
            }
            if (forceUpdate) {
                await fetchFilterData()
                dispatch({ type: 'forceUpdate', forceUpdate: false })
            }
        }
        fetchData()
    }, [vehicleCriteria, forceUpdate, clearFilters])

    React.useEffect(() => {
        if (resetHubCategories) {
            fetchHubCategories()
            dispatch({ type: 'resetHubCategories', resetHubCategories: false })
        }
    }, [resetHubCategories])

    React.useEffect(() => {
        const fetchVehicles = async () => {
            if (paymentInformationUpdate) {
                await fetchListingVehicles()
                dispatch({ type: 'updatePaymentInformation', paymentInformationUpdate: false })
            }
        }
        fetchVehicles()
    }, [paymentInformationUpdate])

    React.useEffect(() => {
        if (!isFirstLoad) {
            const fetchSortingConfigurations = async () => {
                const { sortConfigurations } = await getSortingFiltersAPIUrl(lang, domain, removeHubNameGroup(hubName, lang))

                if (sortConfigurations) {
                    dispatch({
                        type: 'updateSortConfigurations',
                        sortConfigurations,
                    })
                }
            }
            fetchSortingConfigurations()
        }
    }, [hubName])

    const fetchFilterData = async () => {
        dispatch({ type: 'fetchingFilters', isFetchingFilters: true })
        try {
            const urlParams = await fetchUrlParams()
            // Get the general configuration for the listing
            const { filtersConfigurations } = await getShowroom360ConfigListingApiUrl(
                lang,
                domain,
                removeHubNameGroup(hubName, lang)
            )
            // Get Inventory Listing - Filters
            const { data: filters } = await getInventoryFiltersAPIUrl(hubName, lang, urlParams)
            // TODO: We are serializing the whole filter data now,
            // Once we get only the Configurable filter data this might need to change
            const filterMetaData = getFilterMetaData(filters, filtersConfigurations, urlParams).sort(sortBy('order'))
            // Get Promotions Banner
            const slug = selectedHubCategory?.vehicleInventoryHubCategory?.slug || ''
            const paramsPromoBanner = {
                location: `page.inventory-hub.${slug.toLowerCase()}.header`,
            }
            const promoBanner = await getInventoryPromotionsApiUrl(lang, paramsPromoBanner, domain)

            const promoCards = !isHumberview ? await getInventoryPromotionsApiUrl(lang, paramsPromoCards, domain) : []

            dispatch({
                type: 'updateFilters',
                filterMetaData,
                filters,
                promoBanner: promoBanner?.promotions || [],
                promoCards: promoCards?.promotions || [],
                selectedHubCategory,
            })
            dispatch({ type: 'fetchingFilters', isFetchingFilters: false })
        } catch (error) {
            console.error(error)
        }
    }
    // TO DO: Remove after testing promo card changes
    // const fetchPromoCardAndBanner = async () => {
    //     try {
    //         const slug = selectedHubCategory?.vehicleInventoryHubCategory?.slug || ''
    //         const paramsPromoBanner = {
    //             location: `page.inventory-hub.${slug.toLowerCase()}.header`,
    //         }
    //         const promoBanner = await getInventoryPromotionsApiUrl(lang, paramsPromoBanner)

    //         const promoCards = await getInventoryPromotionsApiUrl(lang, paramsPromoCards)

    //         dispatch({
    //             type: 'updatePromoCardsAndBanner',
    //             promoBanner: promoBanner?.promotions || [],
    //             promoCards: promoCards?.promotions || [],
    //         })
    //     } catch (error) {
    //         console.error(error)
    //     }
    // }

    const fetchHubCategories = async () => {
        try {
            const { hubCategories } = await getHubsListAPIUrl(hubName, lang, domain)
            const selectedHubCategory = findSelectedHubCategory(hubName, hubCategories, lang) || {}

            dispatch({
                type: 'updateHubCategories',
                hubCategories,
                selectedHubCategory,
            })
        } catch (error) {
            console.error(error)
        }
    }

    // fetch URL params by considering to provide make and model name in place of makeId and modelId if only one selection exist for make and model
    const fetchUrlParams = async () => {
        const {
            extractUrlParametersAsObject,
            extractPathUrlInfoAsObject,
            getHubPathName,
        } = require('../../utils/handle-url.utils')
        const hubName = initialHubName || getHubPathName(lang, location, orgUnitId)
        let urlParams = extractUrlParametersAsObject()
        const { makeName, modelName } = extractPathUrlInfoAsObject() || {}

        if (makeName) {
            const { data } = await getInventoryFiltersAPIUrl(hubName, lang)
            const { makeId, modelId } = data || {}
            const selectedMakeId = makeId && makeId.filter((make) => make.label.toLowerCase() === makeName)?.[0]?.key
            urlParams = { ...urlParams, ...{ makeId: [selectedMakeId] } }
            if (modelName) {
                const selectedModelId =
                    modelId && modelId.filter((model) => model.label.toLowerCase() === decodeURIComponent(modelName))?.[0].key
                urlParams = { ...urlParams, ...{ modelId: [selectedModelId] } }
            }
        }
        return urlParams
    }
    const fetchPromoCards = async (lang, paramsPromoCards, domain) => {
        let promoCards = []

        if (!isHumberview) {
            promoCards = await getInventoryPromotionsApiUrl(lang, paramsPromoCards, domain)
            dispatch({ type: 'updatePromoCards', promoCards: promoCards?.promotions || [] })
        }

        return promoCards
    }
    /**
     * Fetch updated inventory listing based on the filter selection
     * Fetch updated fitler data
     * pass the filter params from state
     */
    const fetchFilteredInventoryListing = async (urlParams) => {
        dispatch({ type: 'fetching' })

        try {
            // Get Inventory Listing - Vehicles
            const paymentOptions = typeof window !== 'undefined' ? getStorageValue('paymentOptions') : {}
            const promoCards = await fetchPromoCards(lang, paramsPromoCards, domain)

            const config = state.XMSConfig?.configuration ?? {}
            const promotionsDisplaySequence = config.promotionsDisplaySequence

            const promoSequence =
                typeof promotionsDisplaySequence === 'string' && promotionsDisplaySequence.trim() !== ''
                    ? promotionsDisplaySequence
                          .split(',')
                          .map((item) => item.trim())
                          .filter((item) => item !== '0' && item !== 0)
                    : []

            // Verifies if there are any promotions targeting specific models
            const hasPromosByModel = Array.isArray(promoCards?.promotions)
                ? promoCards?.promotions.some(({ modelId }) => modelId)
                : false

            const promoCount =
                promoSequence.length > 0 && Array.isArray(promoCards?.promotions) ? promoCards?.promotions?.length : 0

            const noOfPromoTilesToDisplay =
                showPromoCards && !hasPromosByModel ? (promoSequence.length > promoCount ? promoSequence.length : promoCount) : 0

            const updatedVehicleCriteria = { ...state.vehicleCriteria }

            if (packageVersion === 'premium') {
                const defaultSorting = sortConfigurations?.[0]?.code

                if (!updatedVehicleCriteria?.namedSorting && defaultSorting) {
                    updatedVehicleCriteria.namedSorting = defaultSorting
                }
            }

            if ('limit' in updatedVehicleCriteria && !isNaN(Number(updatedVehicleCriteria.limit))) {
                updatedVehicleCriteria.limit = String(Number(updatedVehicleCriteria.limit) - noOfPromoTilesToDisplay)
            }

            const {
                vehicles = [],
                pagination = {},
                paymentOptionsMetadata = [],
                listingMetadataContext = {},
            } = await getInventoryListingApiUrl(
                hubName,
                lang,
                updatedVehicleCriteria,
                '',
                paymentOptions,
                noOfPromoTilesToDisplay,
                isHumberview //  only crop images for Humberview
            )

            const { displayBaseballCards } = listingMetadataContext

            const updatedVehicles =
                (displayBaseballCards || showPromoCards) && promoCards?.promotions?.length > 0
                    ? getVehiclesWithPromoTiles(
                          vehicles,
                          promoCards?.promotions,
                          state.XMSConfig?.configuration?.promotionsDisplaySequence,
                          true // filter promos only for specific vehicles, if available
                      )
                    : vehicles
            dispatch({
                type: 'updateVehicles',
                vehicles: updatedVehicles,
                pagination,
                paymentOptions: paymentOptionsMetadata,
                displayBaseballCards,
            })

            // Need to trigger page view event only after filter interaction
            // Should not trigger an event on first page load
            state.isFirstLoad ? dispatch({ type: 'setFirstLoadComplete' }) : updatePageView()
            updateListingEvent(state.vehicleCriteria, state.filterMetaData, pagination?.numberOfItems, hubName)

            dispatch({ type: 'fetchSucceed' })
        } catch (error) {
            console.error(error)
        }
    }

    const fetchListingVehicles = async () => {
        dispatch({ type: 'fetching' })

        try {
            // Get Inventory Listing - Vehicles
            const paymentOptions = typeof window !== 'undefined' ? getStorageValue('paymentOptions') : {}
            const selectedPurchaseMethod = paymentOptions?.paymentOptionPurchaseMethod

            const filterPaymentOptions = typeof window !== 'undefined' ? getStorageValue('filterPaymentOptions', {}) : {}

            let finalOptions = filterPaymentOptions[selectedPurchaseMethod] || {}

            const promoCards = await fetchPromoCards(lang, paramsPromoCards, domain)

            const config = state.XMSConfig?.configuration ?? {}
            const promotionsDisplaySequence = config.promotionsDisplaySequence

            const promoSequence =
                typeof promotionsDisplaySequence === 'string' && promotionsDisplaySequence.trim() !== ''
                    ? promotionsDisplaySequence
                          .split(',')
                          .map((item) => item.trim())
                          .filter((item) => item !== '0' && item !== 0)
                    : []

            // Verifies if there are any promotions targeting specific models
            const hasPromosByModel = Array.isArray(promoCards?.promotions)
                ? promoCards?.promotions.some(({ modelId }) => modelId)
                : false

            const promoCount =
                promoSequence.length > 0 && Array.isArray(promoCards?.promotions) ? promoCards?.promotions?.length : 0

            const noOfPromoTilesToDisplay =
                showPromoCards && !hasPromosByModel ? (promoSequence.length > promoCount ? promoSequence.length : promoCount) : 0

            const updatedVehicleCriteria = { ...state.vehicleCriteria }

            if (packageVersion === 'premium') {
                const defaultSorting = sortConfigurations?.[0]?.code

                if (!updatedVehicleCriteria?.namedSorting && defaultSorting) {
                    updatedVehicleCriteria.namedSorting = defaultSorting
                }
            }

            if ('limit' in updatedVehicleCriteria && !isNaN(Number(updatedVehicleCriteria.limit))) {
                updatedVehicleCriteria.limit = String(Number(updatedVehicleCriteria.limit) - noOfPromoTilesToDisplay)
            }
            const {
                vehicles = [],
                pagination = {},
                paymentOptionsMetadata = [],
                listingMetadataContext = {},
            } = await getInventoryListingApiUrl(
                hubName,
                lang,
                updatedVehicleCriteria,
                '',
                {
                    ...paymentOptions,
                    ...finalOptions,
                },
                noOfPromoTilesToDisplay,
                isHumberview // only crop images for Humberview
            )

            const { displayBaseballCards } = listingMetadataContext

            // Trigger SD only when filter is not selected
            if (Object.keys(vehicleCriteria).length === 0) {
                updateListingEvent(state.vehicleCriteria, state.filterMetaData, pagination?.numberOfItems, hubName)
            }
            const updatedVehicles =
                showPromoCards && promoCards?.promotions?.length > 0
                    ? getVehiclesWithPromoTiles(
                          vehicles,
                          promoCards?.promotions,
                          state.XMSConfig?.configuration?.promotionsDisplaySequence,
                          true // filter promos only for specific vehicles, if available
                      )
                    : vehicles

            dispatch({
                type: 'updateVehicles',
                vehicles: updatedVehicles,
                pagination,
                paymentOptions: paymentOptionsMetadata,
                displayBaseballCards,
            })
            // Need to trigger page view event only after filter interaction
            // Should not trigger an event on first page load
            state.isFirstLoad ? dispatch({ type: 'setFirstLoadComplete' }) : updatePageView()

            if (packageVersion !== 'premium' || !isFirstLoad) {
                dispatch({ type: 'fetchSucceed' })
            }

            if (isInitialFetched) dispatch({ type: 'loadingSkeleton', isLoadingSkeleton: false })
        } catch (error) {
            console.error(error)
        }
    }
    // Define a function to get widget tradeIn 360
    const getTradeIn360 = async (item) => {
        const { dealerInfos } = state
        return await getWidgetTradeIn360APIUrl(item, dealerInfos, false, packageVersion)
    }

    const fetchTradeInWidget = async () => {
        const { XMSConfig } = state
        dispatch({ type: 'fetchingTradeInWidget' })
        try {
            const tradeInBeforeListing =
                XMSConfig?.configuration?.displayTradeInBeforeListing && (await getTradeIn360('tradeInBeforeListing'))
            const tradeInBeforePayments =
                XMSConfig?.configuration?.displayTradeInBeforePayments && (await getTradeIn360('tradeInBeforePayments'))
            const tradeInAfterPayments =
                XMSConfig?.configuration?.displayTradeInAfterPayments && (await getTradeIn360('tradeInAfterPayments'))
            const tradeInAfterListing =
                XMSConfig?.configuration?.displayTradeInAfterListing && (await getTradeIn360('tradeInAfterListing'))

            dispatch({
                type: 'updateTradeInWidget',
                tradeInBeforeListing: tradeInBeforeListing || '',
                tradeInBeforePayments: tradeInBeforePayments || '',
                tradeInAfterPayments: tradeInAfterPayments || '',
                tradeInAfterListing: tradeInAfterListing || '',
            })
            dispatch({ type: 'tradeInWidgetFetchSucceed' })
        } catch (error) {
            console.error(error)
        }
    }

    /**
     * Extracts the car name from a string by removing any text after a "|" character.
     * @param {string} str The input string, e.g., "Ford F-150 Lightning | example text".
     * @returns {string} The part of the string before the "|", with leading/trailing whitespace removed.
     */
    const getCarName = (str = '') => {
        const pipeIndex = str.indexOf('|')

        return pipeIndex === -1 ? str : str.substring(0, pipeIndex).trim()
    }

    /**
     * Find promotions only if the title contains a Make + Model from the vehicles on the listing,
     * then puts the promos with no model attached in last
     * @param {*} promotions - Promo card
     * @param {*} vehicles - Vehicles return by API
     * @returns Promotions array containing only non-specific ads or found on the list of vehicles
     */
    const getPromotionsFromListing = (promotions = [], vehicles = []) =>
        promotions
            // allows promotions not linked to any model
            // and removes model-specific promos not found on listing
            .filter(
                ({ title, modelId }) =>
                    !modelId ||
                    vehicles.find(({ make, model }) => {
                        const txt = new RegExp(getCarName(title), 'gi')
                        return `${make?.name} ${model?.name}`.search(txt) >= 0
                    })
            )
            // lowers the priority of non-model-specific promos
            .sort(({ modelId }) => (modelId ? -1 : 1))

    /**
     * Mixing promo tile into the vehicle array as per specified sequence
     * @param {*} oldVehicles - Vehicles return by API
     * @param {*} promotions - Promo card
     * @param {*} sequence - Promo card display sequence from delta
     * @returns Vehicle array with vehicles and promo tiles added into the selected sequence
     */
    const getVehiclesWithPromoTiles = (oldVehicles, promotions, sequence, filterFromListing = false) => {
        let vehicles = oldVehicles && [...oldVehicles]
        let newPromoIndex = 0
        const promoSequence =
            typeof sequence === 'string' && sequence.trim() !== ''
                ? sequence
                      .split(',')
                      .map((item) => item.trim())
                      .filter((item) => item !== '0' && item !== 0)
                : []

        const filteredPromotions = filterFromListing ? getPromotionsFromListing(promotions, vehicles) : promotions

        let promotionsInserted = 0
        const promotionsCount = filteredPromotions?.length

        if (promoSequence && promoSequence?.length && promotionsCount > 0) {
            vehicles =
                promoSequence &&
                promoSequence.reduce((acc, sequenceValue) => {
                    // only add promotions if they haven't
                    // being added yet to avoid repetition
                    if (vehicles && promotionsInserted < promotionsCount) {
                        acc.splice(sequenceValue - 1, 0, filteredPromotions[newPromoIndex])
                        newPromoIndex = (newPromoIndex + 1) % promotionsCount
                        promotionsInserted++
                    }
                    return acc
                }, vehicles)

            return vehicles
        }
        return vehicles
    }

    /**
     * Call to add/update the vehicle criteria on filter selection
     * This need to be called when select/deselect any filter to update the state
     * @param {*} vehicleCriteria
     * @param {*} criteria
     * @param {*} attribute
     * @param { Boolean } isFilter
     * @returns Object with updated vehicle criteria
     */
    const addVehicleCriteria = (vehicleCriteria, criteria, attribute, isFilter) => {
        let currentVehicleCriteria = vehicleCriteria
        let newCriteria

        // For filters such as makeId, modelId ... with multiple values
        if (Array.isArray(criteria)) {
            const filteredMetadatas = criteria.filter((metadata) => {
                return metadata.isSelected
            })
            newCriteria = filteredMetadatas.map((metadata) => {
                return metadata.code
            })
        } else {
            // For filters such as minPrice, maxPrice with single values
            // To check if the filter is an empty by removing the value
            if (isEmptyObject(criteria)) {
                newCriteria = { ...currentVehicleCriteria, [Object.keys(criteria)[0]]: '' }
            } else {
                newCriteria = { ...currentVehicleCriteria, ...criteria }
            }
        }

        // attribute - makeId, modelId etc...
        if (attribute) {
            currentVehicleCriteria = { ...currentVehicleCriteria, ...{ [attribute]: newCriteria } }
        } else {
            currentVehicleCriteria = newCriteria
        }

        if (isFilter && 'page' in currentVehicleCriteria) delete currentVehicleCriteria.page

        return currentVehicleCriteria
    }

    const getFilterMetaData = (filterData, filtersConfigurations, urlParams) => {
        // TODO: Remove filter condition after getting combined filter data from fitler API
        return (
            Object.entries(filterData)
                // .filter(([key]) => key in filtersConfigurations)
                .map(([name, value]) => {
                    let metadatas = []
                    if (value && Array.isArray(value)) {
                        metadatas = value
                            // .filter((metadata) => metadata.count > 0) // Display options that have count > 0
                            .map((metadata) => {
                                return new FilterMetaDataModel({
                                    ...metadata,
                                    code: metadata.key ? metadata.key : metadata.label,
                                    type: FILTER_OPTIONS_TYPES.CHECKBOX,
                                    variant: filtersConfigurations && filtersConfigurations[name]?.variant,
                                    // DO isSelected true for the selected filters metadata based on the URL params
                                    isSelected:
                                        urlParams[name] &&
                                        (Array.isArray(urlParams[name])
                                            ? urlParams[name].includes(metadata.key)
                                            : urlParams[name].split(',').includes(metadata.key.toString())),
                                })
                            })
                    }

                    if (value && isObject(value) && isNumber(value?.min) && isNumber(value?.max)) {
                        metadatas.push(
                            new FilterMetaDataModel({
                                label: 'range',
                                type: FILTER_OPTIONS_TYPES.RANGE,
                                min: value.min,
                                max: value.max,
                            })
                        )
                    }
                    const { displayOnNew, displayOnUsed, label, type, order, variant } = filtersConfigurations[name] || {
                        order: 0,
                    }

                    return {
                        name,
                        displayOnNew,
                        displayOnUsed,
                        label,
                        type,
                        order,
                        variant,
                        metadatas,
                    }
                })
        )
    }

    /**
     * Removes every filter from vehicleCriteria except sort and limit
     * @param {*} vehicleCriteria
     * @returns Object with updated vehicle criteria
     */
    const getEmptyCriteria = (vehicleCriteria) => {
        let newCriteria = {}
        Object.keys(vehicleCriteria).forEach((name) => {
            if (FILTER_OPTIONS_REMOVED_FROM_URL.includes(name)) {
                newCriteria = { ...newCriteria, [name]: vehicleCriteria[name] }
            }
        })
        return newCriteria
    }

    return (
        <ListingContext.Provider value={{ state, addVehicleCriteria, getEmptyCriteria, dispatch }}>
            {children}
        </ListingContext.Provider>
    )
}

ListingProvider.propTypes = {
    /** Initial state data from server side */
    initialData: PropTypes.object,
}

ListingProvider.defaultProps = {
    initialData: {},
}

export { ListingContext, ListingProvider }
